import { render, staticRenderFns } from "./VisualPageManagementTypeSelectPopup.vue?vue&type=template&id=d945b52c&scoped=true"
import script from "./VisualPageManagementTypeSelectPopup.vue?vue&type=script&lang=js"
export * from "./VisualPageManagementTypeSelectPopup.vue?vue&type=script&lang=js"
import style0 from "./VisualPageManagementTypeSelectPopup.vue?vue&type=style&index=0&id=d945b52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d945b52c",
  null
  
)

export default component.exports